import { BreakdownListHelper } from '../helpers/BreakdownListHelper';
import { ColumnHeaderHelper } from '../helpers/ColumnHeaderHelper';
import { MetricTileHelper } from '../helpers/MetricTileHelper';
import { TableModelHelper } from '../helpers/TableModelHelper';
import type { IComponentFacts, ReportComponentId } from '../types/report';
import { BreakdownList } from './BreakdownList';
import { ReportChart } from './charts/ReportChart';
import { ColumnHeader } from './ColumnHeader';
import { EmptyFacts } from './EmptyFacts';
import { MetricTile } from './MetricTile';
import { ModelTable } from './ModelTable';

interface IReportComponentBodyProps {
  componentId: ReportComponentId;
  facts: IComponentFacts;
}

/** Picks the tile, table or chart renderer for a component id. */
export const ReportComponentBody = ({
  componentId,
  facts,
}: IReportComponentBodyProps) => {
  if (facts.resolved.months.length === 0) return <EmptyFacts />;

  const metric = MetricTileHelper.tileIdFor(componentId);
  if (metric) return <MetricTile metric={metric} facts={facts} />;

  const column = ColumnHeaderHelper.columnIdFor(componentId);
  if (column) return <ColumnHeader column={column} facts={facts} />;

  const list = BreakdownListHelper.listIdFor(componentId);
  if (list) return <BreakdownList list={list} facts={facts} />;

  const model = TableModelHelper.forComponent(componentId, facts);
  if (model) {
    return (
      <ModelTable
        model={model}
        currency={facts.currency}
        flagRows={componentId === 'variance_table'}
      />
    );
  }

  return <ReportChart componentId={componentId} facts={facts} />;
};
